<template>
  <div class="vip-order-container">
    <h1>{{ $t('vipOrder.title') }}</h1>
    
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form :inline="true" :model="searchForm" ref="searchForm">
        <el-form-item :label="$t('vipOrder.userAccount')">
          <el-input v-model="searchForm.zhanghao" :placeholder="$t('vipOrder.inputMemberAccount')" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="VIP等级">
          <el-select v-model="searchForm.vipLevel" placeholder="请选择VIP等级" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="普通VIP" value="普通VIP"></el-option>
            <el-option label="银卡VIP" value="银卡VIP"></el-option>
            <el-option label="金卡VIP" value="金卡VIP"></el-option>
            <el-option label="钻石VIP" value="钻石VIP"></el-option>
            <el-option
                v-for="(item, index) in xiangmuleixingOptions"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('vipOrder.vipLevel')">
          <el-input v-model="searchForm.viplevel" :placeholder="$t('vipOrder.inputLevel')" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <!-- 数据加载时显示 -->
    <div v-if="loading" class="loading">
      <el-loading background="rgba(255, 255, 255, 0.7)" :body="true" :text="$t('common.loading')"></el-loading>
    </div>

    <!-- 数据表格 -->
    <el-table
      v-loading="loading"
      :data="orderList"
      border
      stripe
      style="width: 100%"
      class="order-table">
      <el-table-column prop="id" :label="$t('common.id')" width="80" align="center"></el-table-column>
      <el-table-column prop="zhanghao" :label="$t('vipOrder.userAccount')" min-width="120" align="center"></el-table-column>
      <el-table-column prop="vipLevel" :label="$t('vipOrder.vipLevel')" width="120" align="center"></el-table-column>
      <el-table-column prop="amount" :label="$t('vipOrder.purchaseAmount')" width="120" align="center">
        <template slot-scope="scope">
          <span>¥{{ scope.row.amount }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('vipOrder.vipValidityPeriod')" min-width="280" align="center">
        <template slot-scope="scope">
          <div>{{ $t('vipOrder.start') }}: {{ formatDate(scope.row.starttime) }}</div>
          <div>{{ $t('vipOrder.end') }}: {{ formatDate(scope.row.endtime) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('vipOrder.validStatus')" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="getVipStatusType(scope.row)">{{ getVipStatus(scope.row) }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Loading } from 'element-ui'


Vue.use(ElementUI)

export default {
  data() {
    return {
      loading: false, // 加载状态
      orderList: [], // VIP订单数据
      searchForm: {
        zhanghao: '',
        viplevel: ''
      },
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  created() {
    this.fetchVipOrders();
  },
  methods: {
    // 请求后端获取VIP订单记录
    fetchVipOrders() {
      this.loading = true;
      
      // 确保分页参数是数字
      const pageNum = parseInt(this.currentPage);
      const pageSizeNum = parseInt(this.pageSize);
      
      console.log(`准备发送请求: 页码=${pageNum}, 每页条数=${pageSizeNum}`);
      
      this.$http({
        url: "viporder/page",
        method: "get",
        params: {
          page: pageNum,
          limit: pageSizeNum,
          zhanghao: this.searchForm.zhanghao || undefined,
          viplevel: this.searchForm.viplevel || undefined
        }
      }).then(({ data }) => {
        console.log("VIP订单记录响应", data);
        console.log("当前页码:", pageNum, "每页记录数:", pageSizeNum);
        
        if (data && data.code === 0) {
          this.orderList = data.page.list || [];
          this.total = data.page.total || 0;
          console.log("总记录数:", this.total, "列表长度:", this.orderList.length);
        } else {
          this.$message.error(this.$t('vipOrder.getVipOrdersFailed'));
          this.orderList = [];
          this.total = 0;
        }
      }).catch((error) => {
        console.error("加载VIP订单记录失败", error);
        this.$message.error(this.$t('vipOrder.networkError'));
        this.orderList = [];
        this.total = 0;
      }).finally(() => {
        this.loading = false; // 加载完毕，无论成功与否
      });
    },
    
    // 处理查询
    handleSearch() {
      this.currentPage = 1;
      this.fetchVipOrders();
    },
    
    // 重置查询条件
    resetSearch() {
      this.searchForm = {
        zhanghao: '',
        viplevel: ''
      };
      this.currentPage = 1;
      this.fetchVipOrders();
    },
    
    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchVipOrders();
    },
    
    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchVipOrders();
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return this.$t('vipOrder.noData');
      const d = new Date(date);
      if (isNaN(d.getTime())) return this.$t('vipOrder.invalidDate');
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    },
    
    // 获取VIP状态
    getVipStatus(order) {
      if (!order.endtime) return this.$t('vipOrder.notActivated');
      const now = new Date();
      const endTime = new Date(order.endtime);
      if (endTime < now) {
        return this.$t('vipOrder.expired');
      }
      return this.$t('vipOrder.valid');
    },
    
    // 获取VIP状态标签类型
    getVipStatusType(order) {
      const status = this.getVipStatus(order);
      switch (status) {
        case "未激活":
          return "info";
        case "已过期":
          return "danger";
        case "有效":
          return "success";
        default:
          return "info";
      }
    }
  }
};
</script>

<style scoped>
.vip-order-container {
  padding: 20px;
}

h1 {
  margin-bottom: 20px;
  color: #333;
  font-size: 24px;
}

.filter-container {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.order-table {
  margin-bottom: 20px;
}

.pagination-container {
  text-align: center;
  margin-top: 20px;
}
</style> 